/**
 * Format a unix-second timestamp as a humanised relative string ("3 hours ago",
 * "in 2 minutes", "just now"). Uses Intl.RelativeTimeFormat for locale-correct
 * output — currently English only, matches the rest of the app.
 *
 * @param epochSec  unix seconds (the API's `createdAt` field is in this format)
 * @param nowSec    "now" override for testing; defaults to current time
 */
const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export function formatRelativeTime(epochSec: number, nowSec: number = Date.now() / 1000): string {
  const deltaSec = epochSec - nowSec;
  const abs = Math.abs(deltaSec);

  if (abs < 45) return rtf.format(Math.round(deltaSec), 'second');
  if (abs < 90 * 60) return rtf.format(Math.round(deltaSec / 60), 'minute');
  if (abs < 22 * 3600) return rtf.format(Math.round(deltaSec / 3600), 'hour');
  if (abs < 6 * 86400) return rtf.format(Math.round(deltaSec / 86400), 'day');
  if (abs < 26 * 86400) return rtf.format(Math.round(deltaSec / 86400 / 7), 'week');
  if (abs < 320 * 86400) return rtf.format(Math.round(deltaSec / 86400 / 30), 'month');
  return rtf.format(Math.round(deltaSec / 86400 / 365), 'year');
}
